<template>
    <div>
        <div class="lists">
            <div class="listItem flx alc jsb" v-for="item,index in array">
                <div class="liLeft">
                    <div class="liName" v-text="item.name"></div>
                    <div class="liDes" v-text="`${item.title} 丨 分享:${item.share_num} 丨 浏览:${item.view_num}`"></div>
                </div>
                <div class="liMiddle" @click.stop="toCheck(item)">
                    <div class="liTop" v-text="item.num"></div>
                    <div class="liDes">
                        报名活动
                    </div>
                </div>
                <div class="liRight flx alc" :style="type == 2?'visibility:hidden' : ''">
                    <div class="liEdit cursor" style="margin-right: 24px;" @click.stop="toCheck(item)">
                        查看报名
                    </div>
                    <div class="liEdit cursor" style="margin-right: 24px;" @click="toQu(item)">
                        查看渠道
                    </div>
                    <div class="liEdit cursor" @click.stop="showReason(item)" v-if="type == 3"
                        style="margin-right: 24px;color: #FF0F23;">
                        驳回原因
                    </div>
                    <div class="liEdit cursor" v-if="type == 1 || type == 4 || type == 3" @click.stop="delItem(item)" style="margin-right: 24px;">
                        删除
                    </div>
                    <div class="liEdit cursor" v-if="type == 0 || type == 1 || type == 3 || type == 4"
                        style="margin-right: 24px;" @click.stop="toEdit(item)">
                        修改
                    </div>
                    <div class="liEdit cursor" @click.stop="downLine(item)" v-if="type == 0">
                        下线
                    </div>
                    <div class="liEdit cursor" @click.stop="upLine(item)" v-if="type == 1">
                        上线
                    </div>
                   
                </div>
            </div>
        </div>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total" :hide-on-single-page="true">
        </el-pagination>
        <el-dialog title="驳回原因" :visible.sync="centerDialogVisible" width="30%" center>
            <div style="white-space: pre-wrap;" v-text="reasons"></div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="centerDialogVisible = false">我已知晓</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getAcList,
        updownAc
    } from "@/api/index.js"
    export default {
        name: 'acList',
        data() {
            return {
                centerDialogVisible: false,
                activeName: '0',
                info: {
                    level: 2
                },
                array: [],
                showLogin: false,
                page: 1,
                status: 0,
                total: "",
                reasons: ""
            };
        },
        props: ['type'],
        created() {
            this.getList()
        },
        methods: {
            toQu(e){
                this.$router.push({
                    path: '/Channel', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            toCheck(e){
                this.$router.push({
                    path: '/Acform', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            toEdit(e) {
                let that = this
                that.$router.push({
                    path: '/ActivityEdit', // 写路由path
                    query: {
                        id: e.id,
                        source: that.type == 4 ? 2 : 1
                    }
                })
            },
            showReason(e) {
                this.reasons = e.remark
                this.centerDialogVisible = true
            },
            delItem(e){
                let that = this
                let data = {}
                data.id = e.id
                data.type = that.type == 4?4 : 3
                that.$confirm('确定要删除该活动吗?', ' ', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownAc(data).then((res) => {
                        console.log(res)
                        if(res.code == 1){
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        }else{
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {
                   
                });
            },
            upLine(e){
                let that = this
                let data = {}
                data.id = e.id
                data.type = 2
                that.$confirm('确定要上线该活动吗?', ' ', {
                    confirmButtonText: '上线',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownAc(data).then((res) => {
                        console.log(res)
                        if(res.code == 1){
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        }else{
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {
                   
                });
            },
            downLine(e) {
                let that = this
                let data = {}
                data.id = e.id
                data.type = 1
                that.$confirm('确定要下线该活动吗?', ' ', {
                    confirmButtonText: '下线',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownAc(data).then((res) => {
                        console.log(res)
                        if(res.code == 1){
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        }else{
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {
                   
                });
            },
            handleCurrentChange(e) {
                console.log(e)
                this.page = e
                this.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 30
                data.is_status = that.type
                getAcList(data).then((res) => {
                    if (res.code == 1) {
                        that.array = res.data.list.data
                        that.total = res.data.list.total
                        let nums = []
                        nums.push(res.data.num1)
                        nums.push(res.data.num2)
                        nums.push(res.data.num3)
                        nums.push(res.data.num4)
                        nums.push(res.data.num5)
                        that.$emit("getNums", nums)
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    } else {
                        // that.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .liMiddle {
        margin-left: 56px;

    }
    .liLeft{
        width: 40%;
    }
    .liEdit {
        font-size: 16px;
        color: #007AFF;
    }

    .liDes {
        font-size: 14px;
        color: #999999;
        text-align: left;
    }

    .liTop {
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 28px;
        margin-bottom: 4px;
    }

    .liName {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
        text-align: left;
    }

    .liDes {
        font-size: 14px;
        color: #555C70;
    }

    .listItem {
        box-sizing: border-box;
        padding: 20px 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .lists {
        box-sizing: border-box;
        padding: 0 30px 0;
    }

    .acctitle {
        box-sizing: border-box;
        padding: 28px 30px 0;
    }
</style>